<template>
  <div class='coursework-viewer__header kd-form--dark'>
    <a class='coursework-viewer__header_back coursework-viewer__header_mobile-btn' @click="goBack">
      <i class='kf kf-back-arrow'></i>
    </a>
    <div class='coursework-viewer__header_logo'>
      <div class='top-nav--logo'>
        <a data-skip-pjax="true" :href="navigation.header.url">
          <img class="screen-logo" width="104" height="36" :alt="navigation.header.title" :src="navigation.header.logo">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      navigation: Object
    },
    methods: {
      goBack() {
        if (!_.isEmpty(this.navigation.referrer)) {
          if (_.isFunction(this.navigation.referrer.action)) {
            this.navigation.referrer.action()
          } else {
            window.location = this.navigation.referrer.action
          }
        }
      }
    }
  }
</script>